import {ActionType, createAction} from 'typesafe-actions';
import {AccessDTO} from '../../interfaces/AccessDTO';
import {THEME_NUMBER} from '../../themes';
import {TrafficCenter} from '../../interfaces/TrafficCenter';

export const changeCurrentTrafficCenter = createAction(
    'CHANGE_CURRENT_TRAFFIC_CENTER',
    (action) => (trafficCenter: TrafficCenter | null) => action({trafficCenter}),
);

export const changeCurrentTheme = createAction(
    'CHANGE_CURRENT_THEME',
    (action) => (newThemeNumber: THEME_NUMBER) => action({newThemeNumber}),
);

export const storeAccessData = createAction('STORE_ACCESS_DATA', (action) => (data: AccessDTO) => action({data}));

export const userSettingsReducerShowRecordIds = createAction(
    'USER_SETTINGS_REDUCER_SHOW_RECORD_IDS',
    (action) => (value: boolean) => action({value}),
);

export const userSettingsReducerShowTrafficJamIcons = createAction(
    'USER_SETTINGS_REDUCER_SHOW_TRAFFIC_JAM_ICONS',
    (action) => (value: boolean) => action({value}),
);

export const userIsAuthenticated = createAction('USER_IS_AUTHENTICATED', (action) => () => action({}));

export type ActionTypes =
    | ActionType<typeof changeCurrentTheme>
    | ActionType<typeof changeCurrentTrafficCenter>
    | ActionType<typeof storeAccessData>
    | ActionType<typeof userSettingsReducerShowRecordIds>
    | ActionType<typeof userSettingsReducerShowTrafficJamIcons>
    | ActionType<typeof userIsAuthenticated>;
